// extracted by mini-css-extract-plugin
export default {"container":"GradeList__container___twtm6","grade":"GradeList__grade___h7aKA","heading":"GradeList__heading___kdSDT"};